import styled from 'styled-components';

export const StatisticsContent = styled.div`
    display: flex;
    align-items: start;
`;

export const StatisticsHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const StatisticsTitle = styled.p`
    font-family: Roboto Condensed;
    font-size: 16px;
    font-weight: 300;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 50px;
    text-align: center;
`;

export const StatisticsRedirect = styled.span`
    font-weight: bold;
    color: #9ec400;
    cursor: pointer;
    
    &:hover {
        border-bottom: 2px solid #9ec400;
    }
`;

export const StatisticsBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;    
    flex-direction: column;
`;
